module.exports = __webpack_public_path__ + "img/login_page_image.1d130f7.png";